import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/**
 * 文件相关
 * @email WY <yang.wang06@hand-china.com>
 * @creationDate 2019/12/25
 * @copyright HAND ® 2019
 */
import axios from 'axios';
import qs from 'querystring';
import request from "../../utils/request";
import { getIeVersion } from "../../utils/browser";
import { getEnvConfig } from "../../utils/iocUtils";
import notification from "../../utils/notification";
import { filterNullValueObject, getAccessToken, getCurrentOrganizationId, getResponse, getRequestId, isTenantRoleLevel } from "../../utils/utils";
import { getMenuId } from "../../utils/menuTab";
var _getEnvConfig = getEnvConfig(),
  API_HOST = _getEnvConfig.API_HOST,
  HZERO_FILE = _getEnvConfig.HZERO_FILE;
var withTokenAxios = axios.create();
var jsonMimeType = 'application/json; charset=utf-8';
withTokenAxios.defaults = _objectSpread({}, withTokenAxios.defaults, {
  headers: _objectSpread({}, (withTokenAxios.defaults || {}).headers, {
    'Content-Type': jsonMimeType,
    Accept: 'application/json;' // 'X-Requested-With': 'XMLHttpRequest',
  }),

  withCredentials: true
}); // Add a request interceptor

withTokenAxios.interceptors.request.use(function (config) {
  var _config$url = config.url,
    url = _config$url === void 0 ? '' : _config$url;
  if (url.indexOf('://') === -1 && !url.startsWith('/_api')) {
    url = "".concat(API_HOST).concat(url);
  } // Do something before request is sent

  var MenuId = getMenuId();
  if (MenuId) {
    return _objectSpread({}, config, {
      url: url,
      headers: _objectSpread({}, config.headers, {
        Authorization: "bearer ".concat(getAccessToken()),
        'H-Request-Id': "".concat(getRequestId()),
        'H-Menu-Id': "".concat(getMenuId())
      })
    });
  } else {
    return _objectSpread({}, config, {
      url: url,
      headers: _objectSpread({}, config.headers, {
        Authorization: "bearer ".concat(getAccessToken()),
        'H-Request-Id': "".concat(getRequestId())
      })
    });
  }
}, function (err) {
  return Promise.reject(err);
});
withTokenAxios.interceptors.response.use(function (res) {
  var status = res.status,
    data = res.data;
  if (status === 204 || status === 200) {
    return res;
  }
  if (data && data.failed) {
    // notification.error({
    //   message: data.message,
    // });
    throw res;
  } else {
    return res;
  }
}, function (err) {
  throw err;
});
/**
 * 获取fileList
 * {HZERO_FILE}/v1/files/{attachmentUUID}/file
 * todo {HZERO_FILE}/v1/{organizationId}/files/{attachmentUUID}/file
 * @export
 * @param {object} params 传递参数
 * @param {string} params.attachmentUUID - 文件uuid
 */

export function queryFileList(_x) {
  return _queryFileList.apply(this, arguments);
}
/**
 * 获取fileList(租户级)
 * {HZERO_FILE}/v1/{organizationId}/files/{attachmentUUID}/file
 * @export
 * @param {object} params 传递参数
 * @param {string} params.attachmentUUID - 文件uuid
 */

function _queryFileList() {
  _queryFileList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var tenantId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            tenantId = getCurrentOrganizationId();
            return _context2.abrupt("return", request("".concat(HZERO_FILE, "/v1").concat(isTenantRoleLevel() ? "/".concat(tenantId, "/") : '/', "files/").concat(params.attachmentUUID, "/file"), {
              method: 'GET',
              query: params
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _queryFileList.apply(this, arguments);
}
export function queryFileListOrg(_x2) {
  return _queryFileListOrg.apply(this, arguments);
}
/**
 * 删除文件
 * {HZERO_FILE}/v1/files/delete-by-uuidurl/not-null
 * @export
 * @param {object} params 传递参数
 * @param {string} params.bucketName - 桶
 * @param {string} params.attachmentUUID - 文件uuid
 * @param {string} params.storageCode - 存储配置编码
 * @param {string[]} params.urls - 删除文件
 */

function _queryFileListOrg() {
  _queryFileListOrg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var organizationId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            organizationId = getCurrentOrganizationId();
            return _context3.abrupt("return", request("".concat(HZERO_FILE, "/v1/").concat(organizationId, "/files/").concat(params.attachmentUUID, "/file"), {
              method: 'GET',
              query: params
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryFileListOrg.apply(this, arguments);
}
export function removeFileList(_x3) {
  return _removeFileList.apply(this, arguments);
}
/**
 * 删除上传的文件
 * {HZERO_FILE}/v1/files/delete-by-url
 * {HZERO_FILE}/v1/{organizationId}/files/delete-by-url
 * @param {object} params
 * @param {string} params.bucketName
 * @param {string} params.storageCode - 存储配置编码
 */

function _removeFileList() {
  _removeFileList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var urls, otherParams, reqUrl;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            urls = params.urls, otherParams = _objectWithoutProperties(params, ["urls"]);
            reqUrl = "".concat(HZERO_FILE, "/v1/files/delete-by-uuidurl/not-null");
            return _context4.abrupt("return", request(reqUrl, {
              method: 'POST',
              body: params.urls,
              query: filterNullValueObject(otherParams)
            }));
          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _removeFileList.apply(this, arguments);
}
export function removeUploadFile(_x4) {
  return _removeUploadFile.apply(this, arguments);
}
/**
 * 删除attachmentUUID对应的某一个文件
 * {HZERO_FILE}/v1/files/delete-by-uuidurl
 * todo {HZERO_FILE}/v1/{organizationId}/files/delete-by-uuidurl
 * @export
 * @param {object} params 传递参数
 * @param {string} params.bucketName - 桶
 * @param {string} params.attachmentUUID - 文件uuid
 * @param {string[]} params.urls - 要删除的文件
 */

function _removeUploadFile() {
  _removeUploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var urls, otherParams, tenantId, reqUrl;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            urls = params.urls, otherParams = _objectWithoutProperties(params, ["urls"]);
            tenantId = getCurrentOrganizationId();
            reqUrl = isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/").concat(tenantId, "/files/delete-by-url") : "".concat(HZERO_FILE, "/v1/files/delete-by-url");
            return _context5.abrupt("return", request(reqUrl, {
              method: 'POST',
              body: urls,
              query: filterNullValueObject(otherParams)
            }));
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _removeUploadFile.apply(this, arguments);
}
export function removeFile(_x5) {
  return _removeFile.apply(this, arguments);
}
/**
 * 删除attachmentUUID对应的某一个文件(租户级)
 * {HZERO_FILE}/v1/{organizationId}/files/delete-by-uuidurl
 * @export
 * @param {object} params 传递参数
 * @param {string[]} params.urls - 删除的文件
 * @param {string} params.bucketName - 桶
 * @param {string} params.attachmentUUID - 文件uuid
 */

function _removeFile() {
  _removeFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var urls, otherParams, tenantId, reqUrl;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            urls = params.urls, otherParams = _objectWithoutProperties(params, ["urls"]);
            tenantId = getCurrentOrganizationId();
            reqUrl = isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/").concat(tenantId, "/files/delete-by-uuidurl") : "".concat(HZERO_FILE, "/v1/files/delete-by-uuidurl");
            return _context6.abrupt("return", request(reqUrl, {
              method: 'POST',
              body: urls,
              query: filterNullValueObject(otherParams)
            }));
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _removeFile.apply(this, arguments);
}
export function removeFileOrg(_x6) {
  return _removeFileOrg.apply(this, arguments);
}
/**
 * 获取fileList
 * {HZERO_FILE}/v1/files/uuid
 * {HZERO_FILE}/v1/{organizationId}/files/uuid
 * @export
 * @param {object} params 传递参数
 */

function _removeFileOrg() {
  _removeFileOrg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
    var organizationId, bucketName, attachmentUUID, urls, otherParams;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            organizationId = getCurrentOrganizationId();
            bucketName = params.bucketName, attachmentUUID = params.attachmentUUID, urls = params.urls, otherParams = _objectWithoutProperties(params, ["bucketName", "attachmentUUID", "urls"]);
            return _context7.abrupt("return", request("".concat(HZERO_FILE, "/v1/").concat(organizationId, "/files/delete-by-uuidurl"), {
              method: 'POST',
              query: _objectSpread({
                bucketName: bucketName,
                attachmentUUID: attachmentUUID
              }, filterNullValueObject(otherParams)),
              body: urls
            }));
          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _removeFileOrg.apply(this, arguments);
}
export function queryUUID(_x7) {
  return _queryUUID.apply(this, arguments);
}
/**
 * 获取导出Excel的列数据
 * @export
 * @param {object} params 传递参数
 */

function _queryUUID() {
  _queryUUID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
    var tenantId;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            tenantId = getCurrentOrganizationId();
            return _context8.abrupt("return", request("".concat(HZERO_FILE, "/v1").concat(isTenantRoleLevel() ? "/".concat(tenantId, "/") : '/', "files/uuid"), {
              method: 'POST',
              query: params
            }));
          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _queryUUID.apply(this, arguments);
}
export function queryColumn(_x8) {
  return _queryColumn.apply(this, arguments);
}
function _queryColumn() {
  _queryColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var requestUrl, method;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            requestUrl = params.requestUrl, method = params.method;
            return _context9.abrupt("return", method !== 'GET' && method !== 'get' ? request("".concat(requestUrl), {
              method: method,
              body: {
                exportType: 'COLUMN'
              }
            }) : request("".concat(requestUrl), {
              method: method,
              query: {
                exportType: 'COLUMN'
              }
            }));
          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _queryColumn.apply(this, arguments);
}

/**
 * 下载
 * @export
 * @param {object} params 传递参数
 * @param {string} params.requestUrl 下载文件请求的url
 * @param {array} params.queryParams 下载文件请求的查询参数，参数格式为：[{ name: '', value: '' }]]
 */
export function downloadFile(_x9, _x10) {
  return _downloadFile.apply(this, arguments);
}
/**
 * 下载
 * @export
 * @param {object} params 传递参数
 * @param {string} params.requestUrl 下载文件请求的url
 * @param {array} params.queryParams 下载文件请求的查询参数，参数格式为：[{ name: '', value: '' }]]
 */

function _downloadFile() {
  _downloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params, flag) {
    var _ref6, url, oldQueryParams, _ref6$method, method, newUrl, iframeName, iframe, downloadForm, tokenInput, idInput, queryParams;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _ref6 = params || {}, url = _ref6.requestUrl, oldQueryParams = _ref6.queryParams, _ref6$method = _ref6.method, method = _ref6$method === void 0 ? 'GET' : _ref6$method;
            newUrl = !url.startsWith('/api') && !url.startsWith('http') ? "".concat(API_HOST).concat(url) : url;
            iframeName = "".concat(url).concat(Math.random()); // 构建iframe

            iframe = document.createElement('iframe');
            iframe.setAttribute('name', iframeName);
            iframe.setAttribute('id', iframeName);
            iframe.style.width = '0px';
            iframe.style.height = '0px';
            iframe.style.display = 'none'; // 构建form

            downloadForm = document.createElement('form');
            if (getIeVersion() === -1) {
              // 如果当前浏览器不为ie
              // form 指向 iframe
              downloadForm.setAttribute('target', iframeName);
            } // 设置token

            tokenInput = document.createElement('input');
            tokenInput.setAttribute('type', 'hidden');
            tokenInput.setAttribute('name', 'access_token');
            tokenInput.setAttribute('value', "".concat(getAccessToken())); // 设置requestId

            idInput = document.createElement('input');
            idInput.setAttribute('type', 'hidden');
            idInput.setAttribute('name', 'H-Request-Id');
            idInput.setAttribute('value', "".concat(getRequestId())); // 处理post请求时token效验

            if (method === 'POST') {
              newUrl = "".concat(newUrl, "?access_token=").concat(getAccessToken(), "&H-Request-Id=").concat(getRequestId());
            } // 表单添加请求配置

            downloadForm.setAttribute('method', method);
            downloadForm.setAttribute('action', newUrl);
            if (!flag) {
              downloadForm.appendChild(tokenInput);
              downloadForm.appendChild(idInput);
            } // 表单添加查询参数

            if (oldQueryParams && Array.isArray(oldQueryParams)) {
              queryParams = oldQueryParams === null || oldQueryParams === void 0 ? void 0 : oldQueryParams.filter(function (i) {
                return i.value !== null && i.value !== undefined && i.value !== '';
              });
              queryParams.forEach(function (item) {
                var input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', item.name);
                input.setAttribute('value', item.value);
                downloadForm.appendChild(input);
              });
            }
            document.body.appendChild(iframe);
            document.body.appendChild(downloadForm);
            downloadForm.submit(); // setTimeout(() => {
            //   document.body.removeChild(downloadForm);
            //   document.body.removeChild(iframe);
            // }, 2500);

            return _context10.abrupt("return", true);
          case 28:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _downloadFile.apply(this, arguments);
}
export function downloadFileByAxios(params, filename) {
  var _ref = params || {},
    url = _ref.requestUrl,
    oldQueryParams = _ref.queryParams,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'GET' : _ref$method,
    queryData = _ref.queryData;
  var newUrl = !url.startsWith('/api') && !url.startsWith('http') ? "".concat(API_HOST).concat(url) : "".concat(url);
  var queryParams = oldQueryParams && Array.isArray(oldQueryParams) ? oldQueryParams === null || oldQueryParams === void 0 ? void 0 : oldQueryParams.filter(function (i) {
    return i.value !== null && i.value !== undefined && i.value !== '';
  }) : oldQueryParams;
  var reg1 = new RegExp("^".concat(HZERO_FILE, "/v1(/[0-9]*)?/files/redirect-url"));
  var reg2 = new RegExp("^".concat(HZERO_FILE, "/v1(/[0-9]*)?/files/download"));
  var fileUrl = '';
  if (reg1.test(newUrl) || reg2.test(newUrl)) {
    if (queryParams && Array.isArray(queryParams)) {
      queryParams.forEach(function (item) {
        if (item.name === 'url') {
          fileUrl = item.value ? decodeURIComponent(item.value) : '';
        }
      });
    }
    if (fileUrl) {
      var signedParams = {};
      if (queryParams && Array.isArray(queryParams)) {
        queryParams.forEach(function (item) {
          signedParams[item.name] = item.value;
        });
      }
      return querySignedUrl(signedParams).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
          var signedUrl, signedQueryParams, arr;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!getResponse(res)) {
                    _context.next = 7;
                    break;
                  }
                  signedUrl = res.substring(0, res.indexOf('?'));
                  signedQueryParams = qs.parse(res.substring(res.indexOf('?') + 1));
                  arr = [];
                  Object.keys(signedQueryParams).forEach(function (item) {
                    if (signedQueryParams[item] && item !== url) {
                      arr.push({
                        name: item,
                        value: signedQueryParams[item]
                      });
                    }
                  });
                  _context.next = 7;
                  return downloadFile({
                    requestUrl: signedUrl,
                    queryParams: arr,
                    method: 'GET'
                  }, true);
                case 7:
                  return _context.abrupt("return", true);
                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x11) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.error(err);
      }); // const index = fileUrl.lastIndexOf('/');
      // if (index > -1) {
      //  const uuidFileName = fileUrl.substring(index + 1);
      //   if(!uuidFileName.includes('@')||uuidFileName.length<33){
      //     FILE_NAME = uuidFileName;
      //   }
      //   if(uuidFileName.charAt(32) === '@'){
      //     FILE_NAME = uuidFileName.substring(33);
      //   } else {
      //     FILE_NAME = uuidFileName;
      //   }
      // } else {
      //   FILE_NAME = fileUrl;
      // }
      // const index = fileUrl.indexOf('@');
      // if (index > -1) {
      //   FILE_NAME = fileUrl.substring(index + 1);
      // } else {
      //   const s = fileUrl.split('/');
      //   if (s.length > 1) {
      //     FILE_NAME = s[s.length - 1];
      //   } else {
      //     return downloadFile(params);
      //   }
      // }
    }
  }

  var newParams = {}; // 表单添加查询参数

  if (queryParams && Array.isArray(queryParams)) {
    if (queryParams.length > 0) {
      if (newUrl.indexOf('?') === -1) {
        newUrl += "?";
      } else {
        newUrl += "&";
      }
    }
    queryParams.forEach(function (item, index) {
      newParams[item.name] = item.value;
      if (index === 0) {
        newUrl += "".concat(item.name, "=").concat(encodeURIComponent(item.value));
      } else {
        newUrl += "&".concat(item.name, "=").concat(encodeURIComponent(item.value));
      }
    });
  }
  return withTokenAxios(method !== 'GET' && method !== 'get' ? {
    url: newUrl,
    method: method,
    data: queryData,
    baseURL: "".concat(API_HOST),
    responseType: 'arraybuffer'
  } : {
    url: newUrl,
    method: method,
    baseURL: "".concat(API_HOST),
    responseType: 'arraybuffer'
  }).then(function (resp) {
    try {
      var _headers$contentDisp;
      var data = resp.data,
        headers = resp.headers;
      var fileName = ''; // 提取文件名

      var temp = (_headers$contentDisp = headers['content-disposition']) === null || _headers$contentDisp === void 0 ? void 0 : _headers$contentDisp.match(/[fF][iI][Ll][Ee][Nn][Aa][Mm][Ee]=(.*)/)[1];
      fileName = temp;
      if (fileName && (fileName[0] === "'" || fileName[0] === '"')) {
        fileName = fileName.substring(1, fileName.length - 1);
      }
      if (!fileName && filename) {
        fileName = filename;
      }
      if (!fileName) {
        throw Error('cannot get fileName!');
      } // 将二进制流转为blob

      var blob = new Blob([data], {
        type: 'application/octet-stream'
      });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
        window.navigator.msSaveBlob(blob, decodeURIComponent(fileName));
      } else {
        // 创建新的URL并指向File对象或者Blob对象的地址
        var blobURL = window.URL.createObjectURL(blob); // 创建a标签，用于跳转至下载链接

        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', decodeURIComponent(fileName)); // 兼容：某些浏览器不支持HTML5的download属性

        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        } // 挂载a标签

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink); // 释放blob URL地址

        window.URL.revokeObjectURL(blobURL);
      }
      return true;
    } catch (e) {
      var enc = new TextDecoder('utf-8');
      var err = {};
      try {
        err = JSON.parse(enc.decode(new Uint8Array(resp.data)));
        if (!err) {
          var _ref3, _ref4, _ref5;
          notification.autoNotification((_ref3 = err) === null || _ref3 === void 0 ? void 0 : _ref3.type, (_ref4 = err) === null || _ref4 === void 0 ? void 0 : _ref4.message, (_ref5 = err) === null || _ref5 === void 0 ? void 0 : _ref5.description);
        }
      } catch (error) {
        console.error(e);
      }
      throw err;
    }
  });
}
/**
 * initiateAsyncExport 发起异步导出请求
 * @param {string} params - 参数
 */

export function initiateAsyncExport(_x12) {
  return _initiateAsyncExport.apply(this, arguments);
}
/**
 * 查询授权的logo地址
 * @param params
 */

function _initiateAsyncExport() {
  _initiateAsyncExport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
    var url, oldQueryParams, method, queryData, newUrl, queryParams, res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            url = params.requestUrl, oldQueryParams = params.queryParams, method = params.method, queryData = params.queryData;
            newUrl = !url.startsWith('/api') && !url.startsWith('http') ? "".concat(API_HOST).concat(url) : url;
            queryParams = oldQueryParams && Array.isArray(oldQueryParams) ? oldQueryParams === null || oldQueryParams === void 0 ? void 0 : oldQueryParams.filter(function (i) {
              return i.value !== null && i.value !== undefined && i.value !== '';
            }) : oldQueryParams;
            if (queryParams && Object.keys(queryParams).length >= 1) {
              queryParams.forEach(function (item) {
                newUrl += "".concat(newUrl.indexOf('?') >= 0 ? '&' : '?').concat(item.name, "=").concat(encodeURIComponent(item.value));
              });
            }
            res = method !== 'GET' && method !== 'get' ? request(newUrl, {
              method: method,
              body: queryData
            }) : request(newUrl, {
              method: method
            }); // FIXME: @WJC utils need fix
            // @ts-ignore

            return _context11.abrupt("return", getResponse(res));
          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _initiateAsyncExport.apply(this, arguments);
}
export function querySignedUrl(_x13) {
  return _querySignedUrl.apply(this, arguments);
}
function _querySignedUrl() {
  _querySignedUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var tenantId, url, bucketName, storageCode, reqUrl, res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            tenantId = getCurrentOrganizationId();
            url = params.url, bucketName = params.bucketName, storageCode = params.storageCode;
            reqUrl = "".concat(HZERO_FILE, "/v1/").concat(tenantId, "/files/signedUrl");
            _context12.next = 5;
            return request(reqUrl, {
              method: 'GET',
              query: {
                url: url,
                bucketName: bucketName,
                storageCode: storageCode
              },
              responseType: 'text'
            });
          case 5:
            res = _context12.sent;
            return _context12.abrupt("return", getResponse(res));
          case 7:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _querySignedUrl.apply(this, arguments);
}